import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-azul/15 bg-ink-2 p-5" data-id="element-160" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-161" data-mp="3458o4hspz10o">
        <img src={testimonial.img} alt={testimonial.name} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-azul/50" data-id="element-162" data-mp="345qo9pii5zdv" />
        <div className="min-w-0" data-id="element-163" data-mp="19s9b8wfq4kx3">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-164" data-mp="19t0t74geek4w">
            <span className="text-sm font-bold text-white" data-id="element-165" data-mp="1dt1khpoliptd">{testimonial.name}</span>
            <span className="flex gap-0.5 text-naranja" aria-label="5 de 5 estrellas" data-id="element-166" data-mp="htw25cs23u6a">
              {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-167" data-mp="d09p3jhzdo9y" data-mpi={k} />)}
            </span>
          </div>
          <div className="text-xs text-white/50" data-id="element-168" data-mp="34gh8df7iiyi">📍 {testimonial.location}</div>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-white/10 pt-4 text-[15px] leading-relaxed text-white/80" data-id="element-169" data-mp="10rynnhleb8zc">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}